import {Types2D} from "@dp-instant/interfaces";
import {LevelRestartAction} from "@dp-instant/gameflow";
import {InputManager} from "@game/coregame/managers/InputManager";
import {GameModel} from "@game/coregame/model/GameModel";
import Root from "@game/coregame/view/Root";
import {TypesGame} from "@game/TypesGame";
import {inject, injectable} from "inversify";

@injectable()
export class LevelRestartActionSIO extends LevelRestartAction<string> {
    @inject(Types2D.rootView)
    private root: Root;

    @inject(TypesGame.model)
    private model: GameModel;

    @inject(TypesGame.inputManager)
    private inputManager: InputManager;

    protected async launch(levelId: string): Promise<any> {
        this.root.progressBar.hide();
        this.root.overlay.unblur();
        this.model.restartLevel();
        await super.launch();
    }
}
